var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sync-scroll-bars" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _vm.modeEdit &&
              _vm.affaire.affaire.etape ===
                _vm.CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value &&
              _vm.affaire.affaire.status !==
                _vm.CONST.AFFAIRE.STATUS.ARCHIVED.value
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:transfert",
                          value: "creer",
                          expression: "'creer'",
                          arg: "transfert"
                        }
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-plus"
                      },
                      on: {
                        click: function($event) {
                          _vm.dlgNewLineVisible = true
                        }
                      }
                    },
                    [_vm._v("Nouvelle ligne")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          key: _vm.refresh,
          ref: "dataTable",
          staticClass: "transferts",
          attrs: {
            size: "mini",
            data: _vm.lotsDetail,
            "data-sync-scrollbar": "main"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "ordre",
              label: "#",
              fixed: "left",
              width: "40",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      { attrs: { title: "id lot: " + scope.row.id } },
                      [_vm._v(_vm._s(scope.$index + 1))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "left", width: "30", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "purple",
                              color: "white"
                            },
                            attrs: { title: "Avenant travaux supplémentaires" }
                          },
                          [_vm._v("A")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "purple",
                              color: "white"
                            },
                            attrs: { title: "Avenant au marché principal" }
                          },
                          [_vm._v("A")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.TRANSFERT
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "blue",
                              color: "white"
                            },
                            attrs: { title: "Transfert" }
                          },
                          [_vm._v("T")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "green",
                              color: "white"
                            },
                            attrs: { title: "Aléas" }
                          },
                          [_vm._v("L")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION_RISQUE
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "rgb(226, 55, 55)",
                              color: "white"
                            },
                            attrs: { title: "Provision" }
                          },
                          [_vm._v("P")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type_lot_detail ===
                    _vm.CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE
                      ? _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            staticStyle: {
                              "background-color": "#cc9900",
                              color: "white"
                            },
                            attrs: {
                              title: "Ligne supplémentaire Budget affaire"
                            }
                          },
                          [_vm._v("S")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "libelle",
              label: "Lots",
              fixed: "left",
              width: "250"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.libelle))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "prestataire",
              label: "Prestataire",
              fixed: "left",
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.prestataire))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { "class-name": "separator", width: "15" } },
            [_vm._v(" ")]
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "BUDGET GLOBAL AFFAIRE",
              width: "130",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("toCurrency")(
                          _vm.calculs[scope.$index]
                            .mtTotalLotDetailLigneBudgetGlobalAffaire
                        )
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { "class-name": "separator", width: "15" } },
            [_vm._v(" ")]
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "Transfert sur marché S/T", align: "center" } },
            [
              _vm._l(_vm.nbCol, function(col) {
                return _c(
                  "el-table-column",
                  {
                    key: col,
                    attrs: {
                      width: "120",
                      align: "right",
                      "class-name": "tbHeader"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      _vm.calculs[scope.$index].mtTransfert[col]
                                        ? _vm.calculs[scope.$index].mtTransfert[
                                            col
                                          ].mt_transfert
                                        : ""
                                    )
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _vm._v("\n          Transfert n°" + _vm._s(col)),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Créé le " +
                            _vm._s(_vm._f("toDate")(_vm.dateCol(col)))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.gestMens(col)))])
                    ])
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.modeEdit
                ? _c("el-table-column", {
                    attrs: {
                      label: "Transfert n° " + (_vm.nbCol + 1),
                      width: "120",
                      align: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.canAddTransfert(scope)
                                ? _c("el-input", {
                                    directives: [
                                      {
                                        name: "numberonly",
                                        rawName: "v-numberonly"
                                      }
                                    ],
                                    class:
                                      "currency" +
                                      (_vm.calculs[scope.$index]
                                        .mtTotalLotDetailLigneBudgetGlobalAffaire <
                                      0
                                        ? " error"
                                        : ""),
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "mini",
                                      tabindex: "2",
                                      autocomplete: "no"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.handleInput(
                                          scope,
                                          "refresh_calcul"
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.mt_transfert,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "mt_transfert", $$v)
                                      },
                                      expression: "scope.row.mt_transfert"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1074014422
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Total Transfert",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("toCurrency")(
                                _vm.calculs[scope.$index]
                                  .mtTotalLotDetailLigneTransfert
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          key: "TotalLot_" + _vm.refresh,
          staticClass: "transferts",
          attrs: {
            data: _vm.totaux,
            size: "mini",
            "row-class-name": "total",
            border: "",
            "data-sync-scrollbar": "footer"
          }
        },
        [
          _c("el-table-column", { attrs: { width: "40", fixed: "left" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "30", fixed: "left", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { width: "250", fixed: "left" } }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { width: "150", fixed: "left", align: "right" } },
            [_vm._v("S/TOTAL")]
          ),
          _vm._v(" "),
          _c("el-table-column", { attrs: { width: "15" } }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "BUDGET GLOBAL AFFAIRE",
              width: "130",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("toCurrency")(
                          _vm.totaux[scope.$index]
                            .mtTotalLotColonneBudgetGlobalAffaire
                        )
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { width: "15" } }, [_vm._v(" ")]),
          _vm._v(" "),
          _vm._l(_vm.nbCol, function(col) {
            return _c("el-table-column", {
              key: col,
              attrs: { width: "120", align: "right" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            style:
                              _vm.mtTotalLotColonneTransfert(
                                scope.$index,
                                col
                              ) > 0
                                ? "color:red"
                                : ""
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("toCurrencyWithZero")(
                                    _vm.mtTotalLotColonneTransfert(
                                      scope.$index,
                                      col
                                    )
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          _vm._v(" "),
          _vm.modeEdit
            ? _c("el-table-column", {
                attrs: { width: "120", align: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              style:
                                _vm.mtTotalLotColonneTransfert(
                                  scope.$index,
                                  _vm.nbCol + 1
                                ) > 0
                                  ? "color:red"
                                  : ""
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("toCurrencyWithZero")(
                                      _vm.mtTotalLotColonneTransfert(
                                        scope.$index,
                                        _vm.nbCol + 1
                                      )
                                    )
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  525621722
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Total Transfert", width: "120", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        style:
                          _vm.mtTotalLotLigneTransfert(scope.$index) > 0
                            ? "color:red"
                            : ""
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("toCurrencyWithZero")(
                                _vm.mtTotalLotLigneTransfert(scope.$index)
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("dlgNewLineTransfert", {
        attrs: {
          idLot: _vm.idLot,
          ordre: _vm.maxOrdre,
          visible: _vm.dlgNewLineVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.dlgNewLineVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }